import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { money } from "@/lib/constants";
import PosterCard from "@/components/PosterCard";
import AdBanner from "@/components/AdBanner";
import Footer from "@/components/Footer";
import { Disc3, Images, Layers, MapPin } from "lucide-react";

export default function PublicGallery() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/public/gallery/${slug}`).then((r) => setData(r.data)).catch(() => setError(true));
  }, [slug]);

  return (
    <div className="min-h-screen flex flex-col">
      <header className="relative z-20 flex items-center justify-between px-6 lg:px-12 py-5 border-b border-stroke bg-surface/70 backdrop-blur-sm">
        <Link to="/" className="flex items-center gap-2">
          <Disc3 className="text-acid" size={28} />
          <span className="font-display text-3xl text-paper">POSTERVAULT</span>
        </Link>
        <Link to="/register" className="font-mono text-xs uppercase tracking-wider bg-acid text-ink font-bold px-4 py-2.5 hard-shadow">
          Start Your Vault
        </Link>
      </header>

      <section className="relative z-10 px-6 lg:px-12 py-12 flex-1 max-w-7xl w-full mx-auto">
        <AdBanner className="mb-8" />
        {error ? (
          <div className="border border-dashed border-stroke p-16 text-center">
            <div className="font-display text-4xl text-paper">Gallery Not Found</div>
            <p className="font-mono text-sm text-muted-gray mt-2">This gallery is private or does not exist.</p>
            <Link to="/" className="inline-block mt-5 font-mono text-xs uppercase bg-acid text-ink font-bold px-5 py-3">Go Home</Link>
          </div>
        ) : !data ? (
          <div className="font-mono text-sm text-muted-gray animate-pulse">Loading gallery...</div>
        ) : (
          <>
            <div className="font-mono text-xs uppercase tracking-[0.3em] text-acid">Public Collection</div>
            <h1 className="font-display text-5xl lg:text-7xl text-paper leading-none mt-1 ink-offset">
              {data.owner_name}'S VAULT
            </h1>
            <div className="flex flex-wrap gap-4 mt-5">
              <span className="font-mono text-xs text-muted-gray flex items-center gap-1.5"><Images size={14} className="text-acid" /> {data.stats.total_posters} posters</span>
              <span className="font-mono text-xs text-muted-gray flex items-center gap-1.5"><Layers size={14} className="text-cyan" /> {money(data.stats.total_value)} value</span>
              <span className="font-mono text-xs text-muted-gray flex items-center gap-1.5"><MapPin size={14} className="text-gold" /> {data.stats.cities} cities</span>
            </div>

            {data.posters.length === 0 ? (
              <div className="mt-10 border border-dashed border-stroke p-12 text-center font-mono text-sm text-muted-gray">
                This collector hasn't added posters yet.
              </div>
            ) : (
              <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {data.posters.map((p, i) => (
                  <PosterCard key={p.id} poster={p} index={i} publicSlug={slug} onClick={() => {}} />
                ))}
              </div>
            )}
          </>
        )}
      </section>
      <Footer />
    </div>
  );
}
